const obj = {
  id: '',
  value: '',
  text: '',
  eventId: '',
}

export default function GroupModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
}
